import { Input } from "antd";
import React, { useState, useRef, useContext } from "react";
import toast from "react-hot-toast";
import { APIProviderContext } from "../api";
import { useNavigate } from "react-router-dom";
import Loader from "../loader";
import classNames from "classnames";
import Cropper from "react-easy-crop";
import getCroppedImg from "./crop-image";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

var LIMITS = {
  selfname: {
    maxLength: 100,
  },
};

function RemembranceForm() {
  const [formData, setFormData] = useState({
    selfname: "",
    photo: null,
    coordinate: "",
  });

  const [stage, setStage] = useState("intro");
  const imageUploadRef = useRef(null);
  const [imageBlob, setImageBlob] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedConfig, setCroppedConfig] = useState(null);

  const { apiAction } = useContext(APIProviderContext);
  const [isValidatingImage, setIsValidatingImage] = useState(false);
  const [isEnqueuing, setIsEnqueuing] = useState(false);
  const navigate = useNavigate();

  async function handleSubmission() {
    var selfname = formData?.selfname;
    selfname = selfname?.trim?.();

    var email = formData?.email;
    email = email?.trim?.();

    if (stage === "intro") {
      setStage("upload-details");
      return;
    }

    if (stage === "upload-details") {
      // Validate name only
      if (!selfname) {
        toast.error("Please fill in your name");
        return;
      }

      if (selfname?.length < 2) {
        toast.error("Please fill in a valid name");
        return;
      }

      if (!email) {
        toast.error("Please fill in your email");
        return;
      }

      // Validate email using regex
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        toast.error("Please fill in a valid email");
        return;
      }

      // Check if photo is uploaded
      if (!formData?.photo) {
        toast.error("Please upload a photo");
        return;
      }

      try {
        if (isValidatingImage) {
          return;
        }

        setIsValidatingImage(true);

        // Validate image 
        var image = await apiAction("POST", "task/image-validate-upload", formData, "formdata");

        setIsValidatingImage(false);

        if (image) {
          setFormData({ ...formData, photoUrl: image.photoUrl.photoUrl250, photoUrl800: image.photoUrl.photoUrl800 });
        } else {
          toast.error("Failed to validate image");
          return;
        }

      } catch (err) {
        setIsValidatingImage(false);
        const errorMessage = typeof err?.response?.data?.response === "string"
          ? err.response.data.response
          : "Failed to validate image";
        toast.error(errorMessage);
        return;
      }


setIsEnqueuing(true);

const submitData = {
  selfname: selfname,
  email: email,
  photoUrl: image.photoUrl,
  photoUrl800: image.photoUrl800,
};

apiAction("POST", "task/enqueue", submitData, "json")
  .then(data => {
    var newTaskUlid = data?.newTaskUlid;
        
        if(newTaskUlid){
          navigate(`/queue/${newTaskUlid}`);
        }

        setIsEnqueuing(false);
    
    setStage("thank-you");
    setIsEnqueuing(false);
  })
  .catch(err => {
    console.error(err?.response?.data?.response ?? err);
    setIsEnqueuing(false);
    const errorMessage = typeof err?.response?.data?.response === "string"
      ? err.response.data.response
      : "Failed to add to queue";
    toast.error(errorMessage);
  });
    }
  }

  function handleImageUpload(e) {
    const file = e?.target?.files?.[0];

    if (!file) {
      return;
    }

    // Check if file is an image
    if (!file?.type?.includes("image")) {
      toast.error("Please upload a valid image file");
      return;
    }

    // ✅ Photo selection is properly handled here
    setImageBlob(window.URL.createObjectURL(file));
    setFormData({ ...formData, photo: file }); // ✅ Photo is set in state
    setStage("photo-crop");
  }




const containerClass = "w-full max-w-md mx-auto h-screen bg-gradient-to-b  text-white flex flex-col md:max-w-lg overflow-hidden";

  const introContainerVariants = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: { staggerChildren: 0.12, delayChildren: 0.05 },
    },
  };

  const introItemVariants = {
    hidden: { opacity: 0, y: 14 },
    show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } },
  };



  return (
    <div className={containerClass}>
      <input type="file" className="hidden" accept="image/*" ref={imageUploadRef} onChange={handleImageUpload} />
      
      {/* Main content */}
      <div className="flex-1 flex flex-col p-6 md:p-8 mt-10">
        {stage === "intro" && (
          <motion.div
            className="flex-1 flex flex-col min-h-screen items-center text-center"
            variants={introContainerVariants}
            initial="hidden"
            animate="show"
          >
            {/* <motion.img
              variants={introItemVariants}
              src="/images/mosaic-image2.avif"
              className="w-[180px] h-auto mb-6"
            /> */}
            <motion.h1 variants={introItemVariants} className=" mb-2 text-3xl md:text-4xl font-[120px]">
              Join the Mosaic
            </motion.h1>
            <motion.div variants={introItemVariants} className="flex flex-col">
              <p className="text-[16px] leading-relaxed mb-8 opacity-90 mt-6 mb-20">
                Upload your photo to become part of our billboard photo mosaic. Your image will appear as one tile at a unique coordinate on the board. After you submit, we&#39;ll share your coordinate so you can find it.
              </p>
            </motion.div>
            <motion.div variants={introItemVariants} className=" mb-16 md:mb-24">
              <p className="text-xs opacity-75">
                * By continuing, you agree to let us use your photo within the mosaic and display it publicly.
              </p>
              <motion.button 
                variants={introItemVariants}
                onClick={() => handleSubmission()} 
                className="w-full bg-[#0D72FF] text-white hover:bg-[#0d5ecf] rounded-lg text-blue py-3 px-6 font-medium transition-colors mt-6"
              >
                I AGREE
              </motion.button>
              <motion.button 
                variants={introItemVariants}
                onClick={() => navigate("/look")} 
                className="w-full text-white rounded-lg text-blue py-3 px-6 font-medium hover:bg-gray-800 transition-colors mt-6"
              >
                View your spot
              </motion.button>
            </motion.div>
          </motion.div>
        )}

        {/* ✅ Updated upload-details stage with photo preview */}
        {stage === "upload-details" && (
          <div className="flex-1 flex flex-col">
            <h1 className="text-3xl md:text-3xl  font-[120px] mb-6 md:text-3xl">Upload Details</h1>
            
            <div className="flex-1">
              <div className="mb-8">
                <label className="block text-[16px] mb-2">Name</label>
                <Input
                  placeholder="Eg. John Doe"
                  value={formData.selfname}
                  maxLength={LIMITS?.selfname?.maxLength}
                  onChange={(e) => setFormData({ ...formData, selfname: e.target.value })}
                  className="bg-blue-700 border-blue-600 text-white placeholder-blue-300"
                />
              </div>
              <div className="mb-8">
                <label className="block text-[16px] mb-2">Email</label>
                <Input
                  placeholder="Eg. john.doe@example.com"
                  value={formData.email}
                  maxLength={LIMITS?.selfname?.maxLength}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  className="bg-blue-700 border-blue-600 text-white placeholder-blue-300"
                />
              </div>
              {/* ✅ Show image preview if photo is selected */}
              {imageBlob && (
                <div className="mb-6">
                  <p className="block text-[16px] mb-2">Selected Photo</p>
                  <img 
                    src={imageBlob} 
                    alt="Selected photo" 
                    className="rounded-lg max-w-full h-48 object-cover border-2 border-blue-400"
                  />
                  <button 
                    onClick={() => imageUploadRef.current.click()}
                    className="text-blue-200 text-[16px] underline mt-2 hover:text-white"
                  >
                    Change photo
                  </button>
                </div>
              )}

              {/* Photo upload section - only show if no photo selected */}
              {!imageBlob && (
                <div>
                  <div 
                    className="border-2 border-dashed border-blue-400 p-8 text-center cursor-pointer hover:border-blue-300 transition-colors rounded-lg"
                    onClick={() => imageUploadRef.current.click()}
                  >
                    <div className="mb-4">
                      <svg className="w-12 h-12 mx-auto text-blue-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                      </svg>
                    </div>
                    <p className="text-lg font-medium">Add photo</p>
                  </div>
                  <p className="text-xs text-blue-300 mt-2">Accepted formats: JPG, PNG | Max size: 5MB</p>
                </div>
              )}
            </div>

            <button 
              onClick={() => handleSubmission()} 
              className="w-full bg-[#0D72FF] text-white py-2 flex items-center justify-center px-6 h-12 font-medium hover:bg-[#0d5ecf] transition-colors mt-8  mb-16 md:mb-24 rounded-lg"
            >
              {isValidatingImage || isEnqueuing ? <Loader /> : "CONTINUE"}
            </button>
          </div>
        )}

        {/* ✅ Updated photo-crop with 1:1 aspect ratio */}
        {stage === "photo-crop" && (
          <div className="fixed inset-0 bg-black bg-opacity-75 flex flex-col items-center justify-center p-4 z-50">
            <p className="text-white text-lg font-semibold mb-4">Crop your photo</p>
            <div className="w-full max-w-sm aspect-square relative"> {/* ✅ Changed to aspect-square */}
              <Cropper
                image={imageBlob}
                crop={crop}
                zoom={zoom}
                aspect={1} // ✅ Changed from 9/16 to 1 (1:1 aspect ratio)
                minZoom={1} // ✅ Changed minZoom
                restrictPosition={false}
                onCropChange={setCrop}
                onCropComplete={(croppedArea, croppedAreaPixels) => {
                  setCroppedConfig({
                    ...croppedConfig,
                    ...croppedAreaPixels,
                  });
                }}
                onZoomChange={setZoom}
                objectFit="horizontal-cover"
              />
            </div>
            <button 
              onClick={async () => {
                var croppedImage = await getCroppedImg(imageBlob, croppedConfig);
                setImageBlob(window.URL.createObjectURL(croppedImage));
                setFormData({ ...formData, photo: croppedImage });
                setStage("upload-details");
              }} 
              className="bg-[#0D72FF] text-white py-3 px-8 font-medium hover:bg-[#0d5ecf] transition-colors mt-6 rounded-lg"
            >
              Save
            </button>
          </div>
        )}

        {stage === "thank-you" && (
          <div className="flex-1 flex flex-col items-center justify-center text-center">
            <h1 className="text-3xl font-semibold mb-8">Thank you</h1>
            <div className="mb-8">
              <p className="text-lg mb-2">Your photo has been</p>
              <p className="text-lg mb-4">successfully uploaded and is now part of the photomosaic.</p>
              {/* <p className="text-[16px] mb-2">To see your position in the mosaic, visit:</p> */}
              {/* <Link to="/" className="text-blue-200 underline mb-6">photomosaic.colorsofmexico.com</Link> */}
            </div>
            
            <div className="rounded-lg p-6 w-full max-w-xs">
              <p className="text-lg font-semibold mb-4">Your Coordinate</p>
              <div className="bg-white text-blue text-2xl font-bold py-4 px-6 text-center rounded-lg">
                {formData.coordinate || "32G"}
              </div>
            </div>
          </div>
        )}
      </div>

    </div>
  );
}

export {
  RemembranceForm,
};
